export default function baseUrl (){
    let baseURL = process.env.NODE_ENV === 'development' ? 'https://tmit.mittrchina.com/' : 'https://mit.mittrchina.com/'
    return baseURL
}